export default "__VITE_ASSET__ab09fefa__"